module.exports = __webpack_public_path__ + "img/AE.60a4a62f.svg";